// removed by extract-text-webpack-plugin
module.exports = {"activityFlow":"activityFlow__V-9yO"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Activity/index.css
// module id = 1533
// module chunks = 0